import React from 'react';
import ThreeStateValue, { boolToThreeStateValue, threeStateValueToBool } from "./ThreeStateValue";
import FilterWrapper from "./FilterWrapper";
import { SelectInput } from "./SelectField";

const ThreeStateSelectInput: React.FC<ThreeStateSelectInputProps> = props => {
    return (
        <SelectInput
            size='small'
            label={ props.label }
            options={ [
                { label: 'Tak/Nie', value: ThreeStateValue.UNDEFINED },
                { label: 'Tak', value: ThreeStateValue.TRUE },
                { label: 'Nie', value: ThreeStateValue.FALSE }
            ] }
            value={ boolToThreeStateValue(props.value) }
            onChange={ e => props.onChange(threeStateValueToBool(e.target.value as ThreeStateValue)) }
        />
    );
}
export default ThreeStateSelectInput;

export const ThreeStateSelectFilter: React.FC<ThreeStateSelectInputProps> = props => {
    return (
        <FilterWrapper used={ props.value !== undefined }>
            <ThreeStateSelectInput { ...props } />
        </FilterWrapper>
    );
}

export interface ThreeStateSelectInputProps {
    readonly label: string;
    readonly value: boolean | undefined;
    readonly onChange: (value: boolean | undefined) => void;
}